import type { TicketMemberReply, TicketReport } from '../types';

export type ThreadItem =
  | { type: 'report'; at: string; report: TicketReport }
  | { type: 'reply'; at: string; reply: TicketMemberReply };

// Member reports and team replies as one conversation, oldest first.
export function ticketThread(reports: TicketReport[], replies: TicketMemberReply[]): ThreadItem[] {
  return [
    ...reports.map((report): ThreadItem => ({ type: 'report', at: report.created_at, report })),
    ...replies.map((reply): ThreadItem => ({ type: 'reply', at: reply.created_at, reply })),
  ].sort((a, b) => Date.parse(a.at) - Date.parse(b.at));
}

export function threadTime(value: string) {
  return new Date(value).toLocaleString(undefined, {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}
